import { Text } from './text';
import { Title } from './title';

export const SXTypography = {Text, Title};